import React, { Component } from 'react';
import { dashboardActions, userActions } from '../../_actions';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import LoadingOverlay from 'react-loading-overlay';
import { BiRestaurant } from "react-icons/bi";
import { GiCarWheel } from "react-icons/gi";
import { TbMassage } from "react-icons/tb";
import { MdOutlineSportsGymnastics } from "react-icons/md";
import { SiOpenaigym } from "react-icons/si";

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      pageNo: 1,
      size: 10,
      roleId: "",
      userIdCustom: "",
      fieldsUser: {},
      errorsUser: {}
    }
  }

  componentDidMount() {

    let loginData = JSON.parse(localStorage.getItem('adminuser'));
    localStorage.setItem('userIdCustom', JSON.stringify(""));

    this.setState({ roleId: loginData.roleId });
    this.setState({ userIdCustom: "" });

    let temp = {
      "keyWord": "",
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(dashboardActions.getDashboardData(temp));

    let reqData = {
      // "keyWord": this.state.keyWord,
      // "size": this.state.size,
      // "pageNo": 1,
      // "sortBy": "",
      // "sortOrder": "",
      // "fromDate": "",
      // "toDate": "",
      // "size": 100
    }
    this.props.dispatch(userActions.getAllUser(reqData))
  }

  inputStatusChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsUser = this.state.fieldsUser;
    let errorsUser = this.state.errorsUser;
    fieldsUser[name] = value;
    errorsUser[name] = "";
    this.setState({ fieldsUser, errorsUser, userIdCustom: value });

    localStorage.setItem('userIdCustom', JSON.stringify(value));

    let temp = {
      "keyWord": "",
      "userIdCustom": value ? value : this.state.fieldsUser.userId,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(dashboardActions.getDashboardData(temp));
  }

  render() {

    let { dashboard, users } = this.props;
    let { loading, dashboarditems, items, total } = dashboard;
    let { getAllUser } = users;
    let { fieldsUser } = this.state;

    // console.log("usersusersusersusersusers", getAllUser);
    console.log("usersusersusersusersusers", users);

    return (
      <>
        <div >
          <LoadingOverlay
            active={loading}
            className="temp001"
            spinner
            text='Please wait...' />
        </div>

        <div className="z-0 overflow-hidden overflow-y-auto focus:outline-none">
          <div className="relative">
            <div className="relative z-20 flex min-h-screen">
              <div className="flex w-full overflow-hidden ">

                <div className="flex flex-col flex-1 overflow-hidden">
                  <main className="relative flex-1">
                    <div className="p-3 2xl:p-8 sm:p-5">
                      <div className="mx-auto max-w-screen-3xl">
                        {this.state.roleId === 0 ?
                          <div className='w-full flex justify-start py-5'>
                            <div className="w-48 h-full">
                              <label className="block text-xs font-medium text-gray-500 md:text-left" for="userId">Select User:</label>
                              <select id="userId" name="userId" className="w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500"
                                value={fieldsUser && fieldsUser.userId ? fieldsUser.userId : null} onChange={this.inputStatusChange}>
                                <option value={""}>All</option>
                                {getAllUser && getAllUser.length > 0 ? getAllUser.map((element, index) => (
                                  <option value={element._id}>{element.name}</option>
                                )) : null}
                              </select>
                            </div>
                          </div> : null}
                        <section className='pb-4'>
                          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
                            {/* Value card */}
                            {this.state.roleId === 0 ?
                              <div className="flex items-center justify-between p-4 bg-white rounded-md dark:bg-darker">
                                <div>
                                  <h6 className="text-sm font-medium leading-none tracking-wider text-gray-500 uppercase dark:text-primary-light">Current User </h6>
                                  <span className="text-xl font-semibold">{dashboarditems && dashboarditems.userCountToday ? dashboarditems.userCountToday : "0"}</span>
                                </div>
                                <div>
                                  <svg className="w-12 h-12 text-gray-300 dark:text-primary-dark" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" > <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                  </svg>
                                </div>
                              </div> : null}
                            {/* Users card */}
                            <div className="flex items-center justify-between p-4 bg-white rounded-md dark:bg-darker">
                              <div>
                                <h6 className="text-sm font-medium leading-none tracking-wider text-gray-500 uppercase dark:text-primary-light">
                                  Total Leads
                                </h6>
                                <span className="text-xl font-semibold">{dashboarditems && dashboarditems.countLead ? dashboarditems.countLead : "0"}</span>
                              </div>
                              <div>
                                <BiRestaurant className="w-12 h-12 text-gray-300 dark:text-primary-dark" />
                              </div>
                            </div>
                            {/* Orders card */}
                            <div className="flex items-center justify-between p-4 bg-white rounded-md dark:bg-darker">
                              <div>
                                <h6 className="text-sm font-medium leading-none tracking-wider text-gray-500 uppercase dark:text-primary-light">
                                  Total Follow Up
                                </h6>
                                <span className="text-xl font-semibold">{dashboarditems && dashboarditems.countFollowUp ? dashboarditems.countFollowUp : "0"}</span>
                              </div>
                              <div>
                                <GiCarWheel className="w-12 h-12 text-gray-300 dark:text-primary-dark" />
                              </div>
                            </div>
                            {/* Tickets card */}
                            {this.state.roleId === 0 ?
                              <div className="flex items-center justify-between p-4 bg-white rounded-md dark:bg-darker">
                                <div>
                                  <h6 className="text-sm font-medium leading-none tracking-wider text-gray-500 uppercase dark:text-primary-light">
                                    Total Category
                                  </h6>
                                  <span className="text-xl font-semibold">{dashboarditems && dashboarditems.countCategory ? dashboarditems.countCategory : "0"}</span>
                                </div>
                                <div>
                                  <TbMassage className="w-12 h-12 text-gray-300 dark:text-primary-dark" />
                                </div>
                              </div> : null}
                          </div>
                        </section>

                        <section className='pb-4'>
                          <div>Lead Type</div>
                          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
                            <div className="flex items-center justify-between p-4 bg-white rounded-md dark:bg-darker">
                              <div>
                                <h6 className="text-sm font-medium leading-none tracking-wider text-gray-500 uppercase dark:text-primary-light">
                                  New
                                </h6>
                                <span className="text-xl font-semibold">
                                  {dashboarditems && dashboarditems.countLeadGroup && dashboarditems.countLeadGroup.NEW ? dashboarditems.countLeadGroup.NEW : "0"}
                                </span>
                              </div>
                              <div>
                                <BiRestaurant className="w-12 h-12 text-gray-300 dark:text-primary-dark" />
                              </div>
                            </div>
                            <div className="flex items-center justify-between p-4 bg-white rounded-md dark:bg-darker">
                              <div>
                                <h6 className="text-sm font-medium leading-none tracking-wider text-gray-500 uppercase dark:text-primary-light">
                                  Contacted
                                </h6>
                                <span className="text-xl font-semibold">
                                  {dashboarditems && dashboarditems.countLeadGroup && dashboarditems.countLeadGroup.CONTACTED ? dashboarditems.countLeadGroup.CONTACTED : "0"}
                                </span>
                              </div>
                              <div>
                                <BiRestaurant className="w-12 h-12 text-gray-300 dark:text-primary-dark" />
                              </div>
                            </div>
                            <div className="flex items-center justify-between p-4 bg-white rounded-md dark:bg-darker">
                              <div>
                                <h6 className="text-sm font-medium leading-none tracking-wider text-gray-500 uppercase dark:text-primary-light">
                                  Converted
                                </h6>
                                <span className="text-xl font-semibold">
                                  {dashboarditems && dashboarditems.countLeadGroup && dashboarditems.countLeadGroup.CONVERTED ? dashboarditems.countLeadGroup.CONVERTED : "0"}
                                </span>
                              </div>
                              <div>
                                <BiRestaurant className="w-12 h-12 text-gray-300 dark:text-primary-dark" />
                              </div>
                            </div>
                            <div className="flex items-center justify-between p-4 bg-white rounded-md dark:bg-darker">
                              <div>
                                <h6 className="text-sm font-medium leading-none tracking-wider text-gray-500 uppercase dark:text-primary-light">
                                  Qualified
                                </h6>
                                <span className="text-xl font-semibold">
                                  {dashboarditems && dashboarditems.countLeadGroup && dashboarditems.countLeadGroup.QUALIFIED ? dashboarditems.countLeadGroup.QUALIFIED : "0"}
                                </span>
                              </div>
                              <div>
                                <BiRestaurant className="w-12 h-12 text-gray-300 dark:text-primary-dark" />
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </main>
                </div>
              </div>
            </div>
          </div>
        </div>

      </>
    );
  }
}

function mapStateToProps(state) {
  const { dashboard, users } = state;
  return {
    dashboard, users
  };
}
export default connect(mapStateToProps)(Dashboard);
